import { render, staticRenderFns } from "./BindReceiptDesc.vue?vue&type=template&id=1a789c01&scoped=true"
import script from "./BindReceiptDesc.vue?vue&type=script&lang=ts"
export * from "./BindReceiptDesc.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a789c01",
  null
  
)

export default component.exports